import React, { useEffect } from "react";
import ReactGA from "react-ga";
import SocialMediaIcons from "../../components/SocialMediaIcons";

const DownloadsPage = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div className="bg-black px-4 md:px-8 py-32 md:py-56">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-gray-300 mb-4">Don't have the Cashlet App yet?</p>
        <h2 className="text-white text-3xl md:text-5xl font-medium mb-8">
          Download the Cashlet App and start earning today
        </h2>
        <div className="flex justify-center">
          <SocialMediaIcons borderWhite={true} />
        </div>
      </div>
    </div>
  );
};

export default DownloadsPage;
